import type {
    DiscountPaymentOptionApiDto,
    GetDiscountItemApiDto,
    GetDiscountPurchaseOrderApiDto
} from 'tradera/state/services/types/webapi-mytradera-generated';

export enum REFUND_STEP {
    LOADING = 'LOADING',
    ERROR_LOADING = 'ERROR_LOADING',
    START = 'START',
    DONE = 'DONE',
    SLOW = 'SLOW'
}

export enum REFUNDED_PART {
    ITEM = 'Item',
    SHIPPING = 'Shipping',
    FULL = 'Full'
}

export const MODAL_TYPE = {
    BANK_ID: 'BANK_ID',
    SWISH_HANDEL: 'SWISH_HANDEL'
};

export const PAYMENT_OPTIONS = {
    VISA_MASTERCARD: 'VisaMasterCard',
    CARD: 'Card',
    SWISH_HANDEL: 'SwishHandel',
    WALLET: 'Wallet'
};

export const PAYMENT_OPTION_STATUS = {
    AVAILABLE: 'Available',
    UNAVAILABLE_DUE_TO_AMOUNT: 'UnavailableDueToAmount',
    AVAILABLE_WITH_DISTURBANCE: 'AvailableWithDisturbance'
};

export type RefundCheckoutSlice = {
    purchaseOrder?: RefundCheckoutPurchaseOrder;
    currentStep: REFUND_STEP;
    refund: RefundRefundState;
    payment: RefundPaymentState;
    ongoingDiscount?: RefundOngoingDiscount;
};

export type RefundCheckoutPurchaseOrder = GetDiscountPurchaseOrderApiDto & {
    isRefund?: boolean;
    purchaseOrderId?: string;
};

export type RefundRefundState = {
    amount: number | null;
    part?: REFUNDED_PART;
    item?: GetDiscountItemApiDto;
    canContinue: boolean;
    canEdit: boolean;

    isSaving: boolean;
    discountAttemptId?: string;
    discountId?: number;
    error?: string | null;
};

export type RefundPaymentState = {
    selectedPayment?: string | null;
    paymentOptions: DiscountPaymentOptionApiDto[];
    modal: { open: string };
    paymentMethodData: RefundPaymentMethodData;
    isValidPaymentMethod: boolean;

    isPaying: boolean;
    discountPaymentAttemptId?: string;
    error?: string | null;
    isCancelling: boolean;
};

export type RefundPaymentMethodData = {
    swishNumber?: string | null;
};

export type RefundOngoingDiscount = {
    discountId?: number;
    discountPaymentAttemptId?: string;
    paymentMethod?: string;
};
